import { render, staticRenderFns } from "./ModalEditarPrecioModelo.vue?vue&type=template&id=1068c9b8"
import script from "./ModalEditarPrecioModelo.vue?vue&type=script&lang=js"
export * from "./ModalEditarPrecioModelo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports